module.exports = __webpack_public_path__ + "img/card-emtenan-22.fda2ff06.jpg";